import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { AuthPermissions } from 'skipify-types';

import CanAccess from '../../../common/CanAccess';
import { useGetPublicMerchantQuery } from '../../../store/modules/merchant/api';
import { useMerchant } from '../../../contexts/MerchantContext';
import { CreateTransactionForm } from '../components/CreateTransaction/CreateTransactionForm';
import { useCreateTransaction } from '../../../hooks/useCreateTransaction';
import { RecentTransactionsList } from '../components/RecentTransactionsList/RecentTransactionsList';

const CreateTransactionPage = () => {
  const { merchantId } = useMerchant();
  const { data: publicData, isLoading: isLoadingPublicData } = useGetPublicMerchantQuery(
    merchantId,
    { skip: !merchantId },
  );
  const { createTransaction } = useCreateTransaction({ merchantId });

  if (!merchantId || isLoadingPublicData) {
    return (
      <Box sx={{ mt: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress sx={{ color: 'black' }} />
      </Box>
    );
  }

  return (
    <Box sx={{ my: 5 }}>
      <Stack
        sx={{
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          gap: { xs: 7, sm: 7, md: 7, lg: 10 },
        }}
      >
        <CanAccess permissions={[AuthPermissions.CHARGE_MIT, AuthPermissions.CHARGE_OWN_MIT]}>
          <Box sx={{ width: { xs: '100%', sm: '100%', md: '54%' } }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'white',
                borderRadius: 3,
                py: { xs: 2, md: 3 },
                px: { xs: 2, md: 3 },
                filter: 'drop-shadow(0px 24px 48px rgba(16, 24, 40, 0.18))',
              }}
            >
              <Typography
                component="h2"
                fontWeight="semibold"
                sx={{ fontSize: { xs: 14, sm: 16, md: 20 }, mb: 4 }}
              >
                Create card on file transaction
              </Typography>
              <CreateTransactionForm
                merchantId={merchantId}
                onSubmit={createTransaction}
                currency={publicData?.acceptedCurrency}
              />
            </Box>
          </Box>
        </CanAccess>
        <CanAccess permissions={[AuthPermissions.READ_MIT, AuthPermissions.READ_OWN_MIT]}>
          <Box sx={{ width: { xs: '100%', sm: '100%', md: '46%' } }}>
            <RecentTransactionsList merchantId={merchantId} />
          </Box>
        </CanAccess>
      </Stack>
    </Box>
  );
};

export default CreateTransactionPage;
